var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWhiteEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    clipPath: "url(#clip0_1109_5087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.25 3.74998L5 0.833313L8.75 3.74998V8.33331C8.75 8.55433 8.6622 8.76629 8.50592 8.92257C8.34964 9.07885 8.13768 9.16665 7.91667 9.16665H2.08333C1.86232 9.16665 1.65036 9.07885 1.49408 8.92257C1.3378 8.76629 1.25 8.55433 1.25 8.33331V3.74998Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1109_5087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhiteEmpty);
export default __webpack_public_path__ + "static/media/home-white-empty.2007641677c2f6eed1c0dfb7fe0a31a2.svg";
export { ForwardRef as ReactComponent };